export default __webpack_public_path__ + "static/12-898743e49bff263f88400bb657a9acf1.webp";